import { HostingProviderEnum } from 'src/common/external/bambi-api/bambiApi';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';


export const HOSTING_PROVIDER = {
  OTHER: 'other',
  WIX: 'wix',
} as const satisfies Record<string, HostingProviderEnum>;

export const hostingProviderOptions: SelectOption<HostingProviderEnum>[] = [
  {
    label: 'Other',
    value: HOSTING_PROVIDER.OTHER,
  },
  {
    label: 'Wix',
    value: HOSTING_PROVIDER.WIX,
  },
];
